import React from 'react';
import { t } from 'i18next';

type ErrorVerificationProps = {
	title?: string;
	msg?: string;
	checks?: string[];
	onTryAgain?: () => void;
	tryAgainLabel?: string;
	showChecks?: boolean;
};

const DEFAULT_CHECKS = [
	"You're in a well-lit room and there's no glare",
	'Your ID is against a plain, dark background',
	'Your whole ID is in the photo, including all four corners',
	"There's nothing covering any of the details",
];

const ErrorVerification = ({
	title = 'Verification Failed',
	msg = 'Please try again or contact support. Please ensure:',
	checks = DEFAULT_CHECKS,
	onTryAgain,
	tryAgainLabel = 'Try Again',
	showChecks = true,
}: ErrorVerificationProps) => {
	return (
		<div
			className="error-verification-wrapper p-4 d-flex flex-column w-100 d-flex justify-content-center align-items-center"
			style={{
				minHeight: 'calc(100vh - 220px)',
				height: 'auto',
				overflow: 'hidden',
			}}>
			<div className="error-verification-card">
				<div className="error-verification-icon" aria-hidden="true">
					<svg
						viewBox="0 0 24 24"
						className="error-verification-icon-svg"
						role="presentation">
						<path d="M11.001 10h2v5h-2z" />
						<path d="M11 16h2v2h-2z" />
						<path d="M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.99 1.99 0 0 0 .054 1.968A1.98 1.98 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.99 1.99 0 0 0 .054-1.968zM4.661 19L12 5.137L19.344 19z" />
					</svg>
				</div>

				<h2 className="error-verification-title p-2">{t(title)}</h2>
				<p
					className="error-verification-message"
					style={{ overflowWrap: 'break-word' }}>
					{t(msg)}
				</p>

				{showChecks && (
					<ul className="error-verification-list">
						{checks.map((item) => (
							<li key={item}>{t(item)}</li>
						))}
					</ul>
				)}

				{onTryAgain && (
					<button
						type="button"
						className="error-verification-cta mt-6"
						onClick={onTryAgain}>
						{t(tryAgainLabel)}
					</button>
				)}
			</div>
		</div>
	);
};

export default ErrorVerification;
